import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import MarginManagementLayer from "../../components/Trading/MarginManagementLayer";

const MarginManagementPage = () => {
  return (
    <MasterLayout>
      <MarginManagementLayer />
    </MasterLayout>
  );
};

export default MarginManagementPage;
